import React from 'react'
import PropTypes from 'prop-types'
import { RARITIES_ARR } from '../../constants/constants'
import { decimalSafeAdd } from '../../helpers/prices.helper'
import HeroSnapshotBack from './HeroSnapshotBack'
import HeroSnapshotFront from './HeroSnapshotFront'
import HeroSummary from './HeroSummary'
import Owner from './Owner'
import PriceGroup from './PriceGroup'
import './HeroCard.css'

const HeroSnapshot = ({ className, highlights, hero, title, view }) => {
    let classNames = `hero-snapshot ${RARITIES_ARR[hero.rarity]}`
    if (className) classNames += ` ${className}`

    const totalCost = hero.auctionType === 'assisting' ? decimalSafeAdd(hero.price, hero.summonCost) : 0

    return (
        <div className={classNames}>
            <div className="hero-snapshot-title">{title}</div>
            <HeroSummary hero={hero} />
            {view === 'front' && <HeroSnapshotFront hero={hero} />}
            {view === 'back' && <HeroSnapshotBack hero={hero} highlights={highlights} />}
            <div className="hero-snapshot-pricing">
                {hero.price && (
                    <PriceGroup
                        label={
                            <>
                                {`${hero.auctionType === 'sale' ? 'Purchase' : 'Rental'}`}
                                <br />
                                Price
                            </>
                        }
                        value={hero.price}
                        showIcon
                        network={hero.network}
                    />
                )}
                <PriceGroup
                    label={
                        <>
                            Summon
                            <br />
                            Cost
                        </>
                    }
                    value={hero.summonCost}
                    showIcon
                    network={hero.network}
                />
                {hero.auctionType === 'assisting' && (
                    <PriceGroup
                        label={
                            <>
                                Total
                                <br />
                                Cost
                            </>
                        }
                        value={totalCost}
                        showIcon
                        network={hero.network}
                    />
                )}
                <PriceGroup
                    label={
                        hero.generation === 0 ? (
                            <>
                                Total
                                <br />
                                Summons
                            </>
                        ) : (
                            <>
                                Summons
                                <br />
                                Remaining
                            </>
                        )
                    }
                    value={`${hero.maxSummons === 11 ? hero.summons : hero.summonsRemaining}/${
                        hero.maxSummons === 11 ? '∞' : hero.maxSummons
                    }`}
                />
            </div>
            <Owner className="hero-snapshot-owner" owner={hero.owner} />
        </div>
    )
}

HeroSnapshot.propTypes = {
    className: PropTypes.string,
    hero: PropTypes.object,
    highlights: PropTypes.object,
    view: PropTypes.string,
}

HeroSnapshot.defaultProps = {
    view: 'front',
}

export default HeroSnapshot
